import React from 'react'

// eslint-disable-next-line react/display-name
export const withRefundFormProps = WrappedComponent => props => (
  <WrappedComponent
    {...props}
    className={props.error ? 'error' : ''}
    labelFontSize="16px"
    disableBorder
  />
)
